module.exports = __webpack_public_path__ + "static/media/icon_node.f347a266.png";